<template>
  <div class="scrollable-content--width">
    <section>
      <div class="section-content">
        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              1. Is this plan part of a controlled group?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.controlled_group_yesno">
              <roe-radio-input
                v-model="formData.controlled_group_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-full">
          <div class="form-unit">
            <div class="common-label">
              Does the plan have an age requirement for Employee Contributions?
            </div>
          </div>
          <div class="form-unit">
            <roe-age-requirement-select :design="$v.formData">
            </roe-age-requirement-select>
          </div>
          <div class="form-unit"></div>
        </div>

        <template v-if="showAgeRequirements(formData)">
          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">
                Age Requirement for
                <template
                  v-if="+formData.age_requirement_employee_deferrals === 2"
                >
                  the primary group of employees covered by
                </template>
                the plan
              </div>
            </div>
            <div class="form-unit">
              <roe-age-requirement-years-input :design="$v.formData">
              </roe-age-requirement-years-input>
              <div class="input-devider"><!--  --></div>
              <roe-age-requirement-months-input :design="$v.formData">
              </roe-age-requirement-months-input>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row form-row--center-full">
            <div class="form-unit">
              <div class="light-label">
                Apply to the Employer Contribution Match
              </div>
            </div>
            <div class="form-unit">
              <roe-age-requirement-sync-radio :design="$v.formData">
              </roe-age-requirement-sync-radio>
            </div>
            <div class="form-unit"></div>
          </div>
        </template>

        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-full">
          <div class="form-unit">
            <div class="common-label">
              Does the plan have a service requirement for Employee
              Contributions?
            </div>
          </div>
          <div class="form-unit">
            <roe-service-requirement-select :design="$v.formData">
            </roe-service-requirement-select>
          </div>
          <div class="form-unit"></div>
        </div>

        <template v-if="showServiceRequirement(formData)">
          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">
                Service Requirement for
                <template
                  v-if="+formData.service_requirement_employee_deferrals === 2"
                >
                  the primary group of employees covered by
                </template>
                the plan
              </div>
            </div>
            <div class="form-unit">
              <roe-service-requirement-months-input
                :design="$v.formData"
                class="input-wrap--small"
              >
              </roe-service-requirement-months-input>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row form-row--center-full">
            <div class="form-unit">
              <div class="light-label">
                Apply to the Employer Contribution Match
              </div>
            </div>
            <div class="form-unit">
              <roe-service-requirement-sync-radio :design="$v.formData">
              </roe-service-requirement-sync-radio>
            </div>
            <div class="form-unit"></div>
          </div>
        </template>

        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-full">
          <div class="form-unit">
            <div class="common-label">
              On what frequency are newly eligible participants able to enter
              the plan?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.entry_frequency_requirement_picklist_id"
            >
              <v-select
                v-model="formData.entry_frequency_requirement_picklist_id"
                :options="[
                  { code: 1, label: 'One entry frequency for all employees' },
                  {
                    code: 2,
                    label: 'Multiple entry frequencies for different employees'
                  }
                ]"
                :reduce="label => label.code"
                required
              >
              </v-select>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row form-row--center-full">
          <div class="form-unit">
            <div class="light-label">
              Entry Requirement for
              <template
                v-if="+formData.entry_frequency_requirement_picklist_id === 2"
              >
                the primary group of employees covered by
              </template>
              the plan
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.employee_contrib_entry_date_type"
            >
              <v-select
                v-model="formData.employee_contrib_entry_date_type"
                name="employee_contrib_entry_date_type"
                :options="selectOptions.employee_contrib_entry_date_type"
                :reduce="label => label.code"
                required
              >
              </v-select>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="main-label">
              Indicate if any of the following employees are EXCLUDED from
              participating in the plan?
            </div>
          </div>
          <div class="form-unit"></div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="light-label">Union Employees</div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.excluded_union_employees_yesno"
            >
              <roe-radio-input
                v-model="formData.excluded_union_employees_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="light-label">Non-Resident Aliens</div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.excluded_non_resident_aliens_yesno"
            >
              <roe-radio-input
                v-model="formData.excluded_non_resident_aliens_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="light-label">Employees Acquired via M&A</div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.excluded_m_and_a_aquired_employees_yesno"
            >
              <roe-radio-input
                v-model="formData.excluded_m_and_a_aquired_employees_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="light-label">Leased Employees</div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.excluded_leased_employees_yesno"
            >
              <roe-radio-input
                v-model="formData.excluded_leased_employees_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="light-label">Highly Compensated Employees</div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.excluded_hces_yesno">
              <roe-radio-input
                v-model="formData.excluded_hces_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row form-row--center-full">
          <div class="form-unit">
            <div class="light-label">Others</div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.excluded_other_yesno">
              <v-select
                v-model="formData.excluded_other_yesno"
                name="excluded_other_yesno"
                :options="[
                  { code: 0, label: 'No' },
                  {
                    code: 1,
                    label: 'Yes - requires 401(a)(4) or 410(b) Testing'
                  },
                  {
                    code: 2,
                    label: 'Yes - does not require 401(a)(4) or 410(b)'
                  }
                ]"
                :reduce="label => label.code"
                required
              >
              </v-select>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-full">
          <div class="form-unit">
            <div class="common-label">Naics Code 2 digit</div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.naics_code">
              <v-select
                v-model="formData.naics_code"
                name="naics_code"
                :options="selectOptions.naics_codes"
                :reduce="label => label.code"
                required
              >
              </v-select>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";

import { required } from "vuelidate/lib/validators";
import {
  RoeAgeRequirementSelect,
  RoeAgeRequirementYearsInput,
  RoeAgeRequirementMonthsInput,
  RoeAgeRequirementSyncRadio,
  RoeServiceRequirementSelect,
  RoeServiceRequirementMonthsInput,
  RoeServiceRequirementSyncRadio
} from "@/components/_shared/inputs/design/employee-contributions";
import {
  AgeRequirementsMixin,
  ServiceRequirementMixin,
  InvalidFormWatcherMixin
} from "@/components/_shared/inputs/design/_mixins";
import { mapGetters } from "vuex";

export default {
  name: "RoeEligibilityForm",
  props: ["formData"],
  mixins: [
    AgeRequirementsMixin,
    InvalidFormWatcherMixin,
    ServiceRequirementMixin
  ],
  validations() {
    return {
      formData: {
        controlled_group_yesno: { required },
        ...this.ageRequirementValidations(this.formData),
        ...this.serviceRequirementValidations(this.formData),
        entry_frequency_requirement_picklist_id: { required },
        employee_contrib_entry_date_type: { required },
        excluded_union_employees_yesno: { required },
        excluded_non_resident_aliens_yesno: { required },
        excluded_m_and_a_aquired_employees_yesno: { required },
        excluded_leased_employees_yesno: { required },
        excluded_hces_yesno: { required },
        excluded_other_yesno: { required },
        naics_code: { required }
      }
    };
  },
  computed: {
    ...mapGetters(["selectOptions"])
  },
  components: {
    RoeServiceRequirementSyncRadio,
    RoeAgeRequirementSyncRadio,
    RoeAgeRequirementSelect,
    RoeAgeRequirementYearsInput,
    RoeAgeRequirementMonthsInput,
    RoeServiceRequirementSelect,
    RoeServiceRequirementMonthsInput,
    RoeRadioInput,
    RoeErrorMessage
  }
};
</script>
